module.exports = __webpack_public_path__ + "assets/56b94b293c0e869cd67db6eb14166d48.mp4";